import { FunctionComponent } from 'react'
import { LazyLoader as LazyLoaderProps } from './LazyLoader.types'
import './LazyLoader.scss'
import { UXComponentRenderer } from '../../UXComponentRenderer/UXComponentRenderer'
import { useFetchByPath } from 'src/hooks/coreUx/useFetchByPath'

const LoadingSkeleton = () => (
  <div className="loading-skeleton" data-testid="lazy-loader-skeleton">
    <div className="skeleton-item skeleton-rectangle"></div>
    <div className="skeleton-item skeleton-rectangle"></div>
    <div className="skeleton-item skeleton-rectangle"></div>
  </div>
)

export const LazyLoader: FunctionComponent<LazyLoaderProps> = ({
  attributes
}) => {
  const { path } = attributes
  const { items, isLoading, error } = useFetchByPath(path || '')

  // Return empty div for empty path
  if (!path) {
    return <div data-testid="lazy-loader-empty"></div>
  }

  if (isLoading) {
    return <LoadingSkeleton />
  }

  if (error) {
    return (
      <div className="lazy-loader-error" data-testid="lazy-loader-error">
        Sorry, we couldn't load this content right now. Please try again later.
      </div>
    )
  }

  return (
    <div className="core-ux-lazy-loader" data-testid="lazy-loader">
      {items?.map((item, index) => (
        <UXComponentRenderer key={index + item.type} {...item} />
      ))}
    </div>
  )
}
